import React from "react";
import {Button, Modal, Progress, Typography} from "antd";

interface MigrateAllModalProps{
    showMigrateModal: boolean,
    setShowMigrateModal: (show: boolean) => void,
    migratingTest: boolean,
    migratingRelease: boolean,
    migrateConfigs: (type: 'TEST' | 'RELEASE') => void,
    confFrom: string,
    confTo: string,
    migrateProgress: { completed: number, total: number },
}
const { Text } = Typography;

const MigrateAllModal: React.FC<MigrateAllModalProps> = ({showMigrateModal,setShowMigrateModal, migratingTest, migratingRelease, migrateConfigs, confFrom, confTo, migrateProgress}) => {
    const isMigrating = migratingTest || migratingRelease;
    const percent = migrateProgress.total > 0 ? Math.round((migrateProgress.completed / migrateProgress.total) * 100) : 0;

    return(
        <Modal
          open={showMigrateModal}
          footer={null}
          title={`Migrate ${confFrom} to ${confTo}`}
          onCancel={() => setShowMigrateModal(isMigrating ? true : false)}
        >
          <div>
            <Text>
              You are about to migrate all valid {confFrom} to {confTo}?
            </Text>
          </div>
          {isMigrating && migrateProgress.total > 0 && (
            <div style={{ marginTop: 16 }}>
              <Progress percent={percent} status="active" />
              <Text type="secondary">
                Migrated {migrateProgress.completed} of {migrateProgress.total}
              </Text>
            </div>
          )}
          <div style={{ display: "flex", justifyContent: "flex-end" , marginTop: 16}}>
            <Button
              onClick={() => migrateConfigs('TEST')}
              loading={migratingTest}
              disabled={isMigrating}
            >
              Migrate TEST
            </Button>
            <Button
              onClick={() => migrateConfigs('RELEASE')}
              loading={migratingRelease}
              disabled={isMigrating}
              style={{ marginLeft: 8 }}
            >
              Migrate RELEASE
            </Button>
          </div>
        </Modal>
    )
}
export default MigrateAllModal;